import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import { Pause as PauseIcon } from '@mui/icons-material'

interface DemoPauseControlProps {
  readonly visible: boolean
}

export const DemoPauseControl: FC<DemoPauseControlProps> = ({ visible }) => {
  if (!visible) {
    return null
  }

  return (
    <Box sx={containerSx}>
      <PauseIcon sx={iconSx} />
    </Box>
  )
}

// ---------------------------------------------------------------------------
// Styles
// ---------------------------------------------------------------------------

const containerSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '4px',
}

const iconSx: SxProps<Theme> = {
  fontSize: '1.3rem',
  color: 'warning.main',
}
